import { render, staticRenderFns } from "./ItemFilterModalPremiumMarketLayout.vue?vue&type=template&id=6962d4c0&scoped=true&"
import script from "./ItemFilterModalPremiumMarketLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterModalPremiumMarketLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6962d4c0",
  null
  
)

export default component.exports